export default {
  section: (variant: 'productCard' | 'cart' | undefined) => ({
    width: variant === 'productCard' ? '100vw' : '100%',
    height: 'auto',
    p: '16px 0',
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    overflow: 'hidden'
  }),
  container: (sizes: {
    width: number;
    height: number;
  }, variant: 'productCard' | 'cart' | undefined) => ({
    position: 'relative',
    width: '100%',
    maxWidth: variant === 'productCard' ? sizes.width : sizes.width * 0.6,
    maxHeight: variant === 'productCard' ? sizes.height : sizes.height * 0.6,
    mb: '16px',
    img: {
      width: '100%',
      height: 'auto'
    }
  })
};